<template>
    <h2>Change Password</h2>
    <Form @submit="onSubmit" :validation-schema="schema" ref="form" >

        <div v-if="isSuccess" class="mb-3">

            <info-box v-bind:type="'success'">
                <template v-slot:body>
                    <span class="heading">
                        Success

                    </span>

                    <div>
                        <p>
                            Your password has been changed successfully.
                        </p>
                    </div>
                </template>
            </info-box>
        </div>
        <div v-if="hasError"  class="mb-3">

            <info-box v-bind:type="'error'">
                <template v-slot:body>
                    <span class="heading">
                        Error

                    </span>

                    <div>
                        <p>
                           An error has occurred. Please try again.
                        </p>
                    </div>
                </template>
            </info-box>
        </div>

        <div class="row">
            <div class="col-24 col-xl-12">
                <div class="form-group row mb-4">
                    <div class="col-24 col-xl-12">
                        <div class="details-label">
                            Current Password
                        </div>
                        <Field name="account.oldPassword" class="form-control" type="password" v-model="account.oldPassword">
                        </Field>
                        <ErrorMessage name="account.oldPassword" class="error-message" />

                    </div>
                </div>

                <div class="row">
                    <div class="col-24 col-xl-12">
                        <hr />

                    </div>
                </div>

                <div class="form-group row mb-4">
                    <div class="col-24 col-xl-12">
                        <div class="details-label">
                            New Password
                        </div>
                        <Field name="account.password1" class="form-control" type="password" v-model="account.password1">
                        </Field>
                        <ErrorMessage name="account.password1" class="error-message" />

                    </div>
                </div>

                <div class="form-group row mb-4">
                    <div class="col-24 col-xl-12">
                        <div class="details-label">
                            Confirm Password
                        </div>
                        <Field name="account.password2" class="form-control" type="password" v-model="account.password2">
                        </Field>
                        <ErrorMessage name="account.password2" class="error-message" />

                    </div>
                </div>


                <div class="form-group row">
                    <div class="col-24">
                        <div class="btn-container-start">
                            <div class="d-flex flex-row">
                                <button ref="submit" class="btn btn--slate-blue" type="submit">Update</button>
                                <div v-if="isLoading" style="max-height: 66px; margin-left: 10px;">
                                    <loader></loader>
                                </div>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        </div>
    </Form>

</template>

<script>

    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";
    import { accountStore } from '../store/index';
    import InfoBox from '@/shared/components/InfoBox.vue';
    import Loader from '@/shared/components/Loader.vue';
    export default {
        name: 'AccountChangePassword',
        components: {
            Field,
            Form,
            ErrorMessage,
            InfoBox,
            Loader
        },
        data() {
            const schema = yup.object().shape({
                account: yup.object().shape({
                    oldPassword: yup.string().nullable().required().label("Old password"), 
                    password1: yup.string().nullable().required().min(8).label("Password"),
                    password2: yup.string().nullable().test('passwords-match', 'Passwords must match', function (value) {
                        if (this.parent.password1 != null) {
                            return this.parent.password1 === value;
                        }
                        return false;
                    }).label("Confirm password")
                })
            });

            const account = {
                oldPassword : null,
                password1 : null,
                password2 : null,
            }

            return {
                isLoading: false,
                isSuccess: false,
                hasError: false,
                account,
                schema

            }
        },
        methods: {
            onSubmit(values, { resetForm }) {
                var o = this;
                this.hasError = false;
                this.isSuccess = false;
                this.isLoading = true;
                accountStore.dispatch("changePassword", values.account).then(() => {
                    o.isLoading = false;
            
                    o.isSuccess = true;
                    o.$refs.form.resetForm();
                    o.$refs.submit.focus();
   
                
                }).catch(() => {
                    o.isLoading = false;
                    o.hasError = true;
                    o.isSuccess = false;
                    o.$refs.form.resetForm();
                    o.$refs.submit.focus();
              
                });


            }

        }

    }
</script>

<style>
</style>
